var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconWomanColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4E342E",
    d: "M19.186 24.128s-3.488-1.163-6.395-1.163c-2.907 0-6.396 1.163-6.396 1.163V17.15h12.791v6.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.977 14.826a2.326 2.326 0 11-4.652 0 2.326 2.326 0 014.652 0m16.279 0a2.326 2.326 0 11-4.652 0 2.326 2.326 0 014.652 0",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M20.93 9.012c0-7.399-16.279-4.817-16.279 0v5.232c0 4.816 3.645 8.721 8.14 8.721 4.494 0 8.14-3.905 8.14-8.72V9.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.442 13.663a1.162 1.162 0 11-2.325 0 1.162 1.162 0 012.325 0m-6.977 0a1.162 1.162 0 11-2.325 0 1.162 1.162 0 012.325 0",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785449",
    d: "M12.79.872C7.847.872.582 3.78.51 19.477l5.886 4.65V12.5l9.739-5.233 2.98 4.07.072 12.79L25 19.478c0-6.977-.316-16.86-8.72-16.86L15.115.871H12.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "M9.884 18.895h5.814s-1.163 1.745-2.907 1.745-2.907-1.745-2.907-1.745z"
  }))));
}

export default SvgCommonIconWomanColor;